import { render, staticRenderFns } from "./Analises.vue?vue&type=template&id=8d66b37c&"
import script from "./Analises.vue?vue&type=script&lang=js&"
export * from "./Analises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports